import React from 'react';
import styles from '../../../assets/styles/globals.scss';

function FavoritesStarIcon(props) {

  return (
    <svg width="10px" height="10px" viewBox="204 252 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs></defs>
      <polygon id="featured-copy-5" stroke="none" fill={props.fillColor || styles.warmGreyTwo} fillRule="evenodd" points="207.818182 255.846154 209.011273 252 210.181818 255.846154 214 255.846154 210.909091 258.153846 212.212182 262 209 259.692308 205.939454 262 207.091091 258.148654 204 255.846154"></polygon>
    </svg>
  );
}

export default FavoritesStarIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/FavoritesStarIcon/index.js